import { render, staticRenderFns } from "./marketplaceSalesLedger.vue?vue&type=template&id=5c3201e6&scoped=true"
import script from "./marketplaceSalesLedger.vue?vue&type=script&lang=js"
export * from "./marketplaceSalesLedger.vue?vue&type=script&lang=js"
import style0 from "./marketplaceSalesLedger.vue?vue&type=style&index=0&id=5c3201e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3201e6",
  null
  
)

export default component.exports